// Safe queue init (legacy snippet)
window.klaviyo = window.klaviyo || [];
window.klaviyo.init({
  account: "VT8BKk",
  platform: "shopify",
  // IMPORTANT: set your marketing List ID here so BIS checkbox subscribes to it
  list: "Si7iX9"
});

// Give the auto-inserted trigger a class we control: .bis-button
window.klaviyo.enable("backinstock", {
  trigger: {
    product_page_text: "NOTIFY ME WHEN RESTOCKED",
    product_page_class: "button bis-button" // keep 'button' if your theme styles it
  },
  modal: {
    headline: "GET NOTIFIED",
    body_content: "Enter your email to be notified when {product_name} restocks.",
    email_field_label: "Email",
    button_label: "Notify me",
    subscription_success_label: "Thanks! We will email you when it is back in stock.",
    // Show Klaviyo's own opt-in text so it appears even without our CSS hack
    newsletter_subscribe_label:
      "Leave this ticked to receive notifications when this product is back in stock."
  }
});

// Add stable hooks to the injected popup so we can style with CSS
(function () {
  var once = false;
  var obs = new MutationObserver(function () {
    if (once) return;
    var modal = document.querySelector('.klaviyo_modal');
    var overlay = document.querySelector('.klaviyo_modal_bg');
    if (modal) { modal.classList.add('bis-modal'); }
    if (overlay) { overlay.classList.add('bis-overlay'); }
    if (modal || overlay) { once = true; }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.klaviyo-bis-trigger, .bis-button')) {
      setTimeout(function () {
        var modal = document.querySelector('.klaviyo_modal');
        var overlay = document.querySelector('.klaviyo_modal_bg');
        if (modal) modal.classList.add('bis-modal');
        if (overlay) overlay.classList.add('bis-overlay');
      }, 50);
    }
  });
})();

// ---- Inject styles and behaviour into the Klaviyo BIS iframe ----
(function () {
  function injectIntoIframe() {
    var iframe = document.getElementById('klaviyo-bis-iframe');
    if (!iframe) return false;

    var doc;
    try {
      doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
    } catch (e) { return true; } // different origin, cannot style

    if (!doc || !doc.head || !doc.body) return false;
    if (!doc.querySelector('#klaviyo-bis-modal')) return false; // modal not built yet

    var css = `
/* 1) Submit button look and white text */
#klaviyo-bis-modal .control-group.submit-container > button.btn.btn-success.btn-lg.col-xs-12{
  color:#fff !important;
  -webkit-text-fill-color:#fff !important;
  background:#000 !important;
  border-color:#000 !important;
  text-transform:uppercase;
  border-radius:50px !important;
  font-family: var(--font-heading-family, "Avenir Next", sans-serif);
  font-size:1.6rem; font-weight:700; line-height:2.4rem;
  transition: all .3s ease-in-out .2s;
}
#klaviyo-bis-modal .control-group.submit-container > button.btn.btn-success.btn-lg.col-xs-12:hover{
  transform: translate(-.2rem, -.2rem);
  box-shadow: .6rem .8rem 0 .1rem #000;
}
#klaviyo-bis-modal .control-group.submit-container > button.btn.btn-success.btn-lg.col-xs-12:active{
  transform: translate(0,0);
  box-shadow: .2rem .3rem 0 0 #000;
}

/* 2) Email input radius 40px */
#klaviyo-bis-modal input.form-control.input-lg{
  border:.2rem solid #000 !important;
  border-radius:40px !important;
  height:auto; min-height:46px; padding:1rem 1.2rem;
  font-size:1.6rem; line-height:2.4rem;
}

/* 3) Centre modal on mobile with 30vh top padding */
#klaviyo-bis-modal.in{ height:100% !important; }
@media (max-width: 767px){
  #klaviyo-bis-modal{
    display:block !important;
    padding:30vh 16px 10vh !important;
    box-sizing:border-box !important;
  }
  #klaviyo-bis-modal #container{
    margin-top:0 !important;
    margin-left:auto !important; margin-right:auto !important;
  }
}

/* 4) Heading uses TypefaceSix */
#klaviyo-bis-modal .modal-title{
  font-family: "TypefaceSix", var(--font-heading-family, "Avenir Next"), sans-serif !important;
  font-weight:700; text-transform:uppercase;
}

/* 5) Close button black */
#klaviyo-bis-modal .close{ color:#000 !important; }

/* 6) Add 10px margin to the container and keep your border/shadow */
#klaviyo-bis-modal #container{
  margin:10px auto !important;
  border:.2rem solid #000; box-shadow:.4rem .6rem 0 .1rem #000;
}

/* 7) Success banner: black with white text and link */
#klaviyo-bis-modal .alert-success{
  background-color:#000 !important; font-size:16px !important; font-weight:500 !important;
  border-color:#fff !important; color:#fff !important;
}
#klaviyo-bis-modal .alert-success a{ color:#fff !important; font-weight:700 !important; text-decoration:underline; }
#klaviyo-bis-modal .alert.alert-success{
  background-color:#000 !important; border-color:#fff !important; color:#fff !important;
}
#klaviyo-bis-modal .alert.alert-success a{ color:#fff !important; font-weight:700 !important; }

/* 8) Show and style the newsletter opt-in */
#newsletter_subscription{ display:block !important; margin-top:12px !important; }
#subscribe_for_newsletter{ accent-color:#000; width:18px; height:18px; }
#klaviyo-bis-modal label[for="subscribe_for_newsletter"]{ font-size:14px !important; }

/* Optional, ensure dark overlay if their CSS glitches */
body.fadein{ background: rgba(0,0,0,0.65) !important; }
`;

    var style = doc.getElementById('bis-iframe-styles');
    if (!style) {
      style = doc.createElement('style');
      style.id = 'bis-iframe-styles';
      style.type = 'text/css';
      doc.head.appendChild(style);
    }
    style.textContent = css;

    // Behaviour: show checkbox, set label text as a fallback, require it, and validate on submit
    var cbWrap = doc.getElementById('newsletter_subscription');
    var cb = doc.getElementById('subscribe_for_newsletter');
    if (cbWrap) cbWrap.style.display = 'block';
    var label = doc.querySelector('label[for="subscribe_for_newsletter"]');

    if (cb) {
      cb.checked = true;           // default on; change to false if you prefer
      cb.required = true;
      cb.setAttribute('aria-required', 'true');

      // Fallback label in case the built-in label did not render
      if (label) {
        label.textContent = 'You must tick this to receive notifications when this product is back in stock.';
      }

      // Error container
      var err = doc.getElementById('bis-optin-error');
      if (!err) {
        err = doc.createElement('div');
        err.id = 'bis-optin-error';
        err.style.cssText = 'display:none;color:#C72E2F;font-size:13px;margin-top:8px;';
        if (label && label.parentNode) label.parentNode.appendChild(err);
        else if (cbWrap) cbWrap.appendChild(err);
      }

      // Disable submit until box is ticked; validate on submit
      var form = doc.querySelector('#klaviyo-bis-modal form');
      var submitBtn = doc.querySelector('#klaviyo-bis-modal .submit-container button[type="submit"]');

      function toggleSubmit() {
        if (!submitBtn) return;
        if (cb.checked) { submitBtn.removeAttribute('disabled'); err.style.display = 'none'; }
        else { submitBtn.setAttribute('disabled', 'disabled'); }
      }
      cb.addEventListener('change', toggleSubmit);
      toggleSubmit();

      if (form) {
        form.addEventListener('submit', function (e) {
          if (!cb.checked) {
            e.preventDefault();
            e.stopPropagation();
            err.textContent = 'Please tick the box to receive notifications.';
            err.style.display = 'block';
            if (submitBtn) submitBtn.removeAttribute('disabled');
          }
        });
      }
    }

    return true;
  }

  // Run when the trigger opens the modal
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.klaviyo-bis-trigger, .bis-button')) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (injectIntoIframe() || tries > 60) clearInterval(iv); // up to ~6s
      }, 100);
    }
  });

  // Also try when the iframe or modal nodes appear
  var mo = new MutationObserver(function () { injectIntoIframe(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
